export default "__VITE_ASSET__ce190b2a__"